import { useEffect, useState } from "react"
import { DefineLotForm } from "./defineLotForm"
import { Modal, ModalId, useUIState } from "../../../../../features/ui"
import { DeliveryItemRow, DeliveryItemLotData } from "../../types"

type Props = {
    currentItem?: DeliveryItemRow
    onSubmit: (data: DeliveryItemLotData) => void
}

export const DefineLotFormModal = (props: Props) => {
    const { currentItem, onSubmit } = props
    
    const [key, setKey] = useState(0)
    
    const { openedModal } = useUIState()

    useEffect(() => setKey(key + 1), [openedModal])
    
    return (
        <Modal
            modalId={ModalId.DEFINE_LOT_FORM}
            title="Definir Partida"
            actions={[]}
            widthSize="m"
        >
            <DefineLotForm
                key={key}
                currentItem={currentItem}
                onSubmit={onSubmit}
            />
        </Modal>
    )
}
